<template>
    <v-container class="max-container">
        <v-row class="profile-responsive__row">
            <v-col xs="12" :sm="dynamicMdPicture" :md="dynamicMdPicture" lg="4" class="profile__picture__container no-pd-t">
                <h2 v-if="!mobileVersion" class="profile__title"> Foto do perfil </h2>

                <v-avatar :size="avatarDynamicSize" class="profile__picture" :style="{ 'border': '2px solid ' + currentCompany.primaryColor}">
                    <v-img v-if="userImage || userImage != null" :src="userImage" class="img-container">

                        <div v-if="mobileVersion" class="icon-container" :loading="uploadBtnLoading" @click="buttonUploadClick()">
                            <img class="icon-img" src="@/assets/camera-icon.png">
                        </div>
                    </v-img>

                    <v-img v-if="!userImage || userImage == null" src="@/assets/default-user.png" class="img-container">

                        <div v-if="mobileVersion" class="icon-container" :loading="uploadBtnLoading" @click="buttonUploadClick()">
                            <img class="icon-img" src="@/assets/camera-icon.png">
                        </div>
                    </v-img>
                </v-avatar>
                
                <v-btn v-if="!mobileVersion" outlined color="var(--cor--preta)" class="custom-btn" :loading="uploadBtnLoading" @click="buttonUploadClick()">
                    <v-icon left> mdi-camera </v-icon>
                    <span class="text-none btn__text-icon"> Alterar foto </span>
                </v-btn>
                <input
                    style=" display:none;"
                    type="file"
                    ref="fileInput"
                    accept="image/*"
                    @change="uploadImage($event.target.files)"
                >

                <v-btn v-if="!mobileVersion && !profileObject.facebookConnected" color="var(--cor--facebook)" :loading="loadingFacebookBtn" class="custom-btn facebook-btn" @click="connectFacebook()">
                    <v-icon left color="var(--cor--branco)"> mdi-facebook </v-icon>
                    <span class="btn__text-icon facebook-btn__text text-none"> Vincular facebook </span>
                </v-btn>

                <v-btn v-if="!mobileVersion && profileObject.facebookConnected" color="var(--cor--facebook)" :loading="loadingFacebookBtn" outlined class="custom-btn" @click="disconnectFacebook()">
                    <v-icon left color="var(--cor--facebook)"> mdi-facebook </v-icon>
                    <span class="btn__text-icon text-none"> Desvincular facebook </span>
                </v-btn>
                <v-btn v-if="!mobileVersion" :color="currentCompany.buttonsColor" text class="custom-btn no-mg-b" @click="openChangePasswordModal()">
                    <span class="text-none"> Alterar senha </span>
                </v-btn>

                <v-btn color="var(--cor--roza)" text class="custom-btn" @click="opneModalDeleteAccount()">
                    <span class="text-none"> Excluir minha conta </span>
                </v-btn>
            </v-col>
            
            <v-col xs="12" :sm="dynamicMdForm" :md="dynamicMdForm" lg="8" class="no-pd-t">
                <v-form v-model="valid" class="w-100">
                    <v-row :class="!mobileVersion? 'w-80' : 'w-100'" class="profile-form__row">
                        <v-col sm="12" md="12" lg="12">
                            <div>
                                <v-icon> mdi-account-outline </v-icon> Nome completo
                            </div>
                            <v-text-field
                                color="var(--cor--preta)"
                                clearable
                                v-model="profileObject.name"
                                placeholder="João Silva"
                                @input="inputHasChanged()"
                                :error-messages="completeNameErrors"
                                @change="$v.profileObject.name.$touch(), setUpperCaseName()"
                                @blur="$v.profileObject.name.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="12" md="12" lg="12">
                            <div>
                                <v-icon>mdi-file-outline</v-icon>CPF
                            </div>
                            <v-text-field
                                color="var(--cor--preta)"
                                clearable
                                v-model="profileObject.cpf"
                                placeholder="CPF"
                                v-mask="'###.###.###-##'"
                                @input="inputHasChanged()"
                                :error-messages="cpfErrors"
                                @change="$v.profileObject.cpf.$touch()"
                                @blur="$v.profileObject.cpf.$touch()"
                            ></v-text-field>
                        </v-col>

                        <v-col sm="12" md="12" lg="12">
                            <div>
                                <v-icon>mdi-mdi-state</v-icon>Estado
                            </div>                         

                              <v-select
                                color="var(--cor--preta)"
                                clearable                                
                                placeholder="ESTADO"
                                :items="estados"
                                item-value="id"
                                item-text="name"
                                v-model="estado"               
                            ></v-select>
                        </v-col>
                   
                        <v-col sm="12" md="12" lg="12">
                            <div>
                                <v-icon>mdi-mdi-city</v-icon>Cidade
                            </div>                         

                              <v-autocomplete                                                                                     
                                    color="var(--cor--preta)"
                                    clearable                                
                                    placeholder="Escolha a cidade"
                                    :items="cidades"
                                    item-value="id"
                                    item-text="name"
                                    v-model="profileObject.cidade"
                                    :search-input.sync="search"
                                    :disabled="!estado"
                                    :error-messages="cidadeErrors"
                                    @change="$v.profileObject.cidade.$touch()"
                                    @blur="$v.profileObject.cidade.$touch()"
                                    />
                        </v-col>

                        <v-col sm="6" md="12" lg="6">
                            <div class="flex-row-center-space-between">
                                <div style="max-width: 80px;">
                                    <v-icon> mdi-email-outline </v-icon> E-mail
                                </div>
                                <v-btn v-if="emailConfirmed" height="24px" :color="currentCompany.primaryColor" text class="custom-btn no-mg-b" :loading="confirmationBtnLoader" @click="reSendConfirmation()">
                                    <span class="text-none"> Reenviar confirmação</span>
                                </v-btn>
                            </div>
                            <v-text-field
                                color="var(--cor--preta)"
                                placeholder="seuemail@email.com"
                                clearable
                                v-model="profileObject.email"
                                @input="inputHasChanged()"
                                @change="$v.profileObject.email.$touch()"
                                @blur="$v.profileObject.email.$touch()"
                                :error-messages="emailErrors"
                            >
                            </v-text-field>
                        </v-col>

                        <v-col sm="6" md="6" lg="6">
                            <div>
                                <v-icon> mdi-phone </v-icon> Telefone
                            </div>
                            <v-text-field
                                color="var(--cor--preta)"
                                placeholder="(88) 8 8888-8888"
                                v-mask="['(##) # ####-####','(##) ####-####']"
                                clearable
                                v-model="profileObject.telephone"
                                @input="inputHasChanged()"
                                @change="$v.profileObject.telephone.$touch()"
                                @blur="$v.profileObject.telephone.$touch()"
                                :error-messages="telephoneErrors"
                            ></v-text-field>
                        </v-col>

                        <v-col sm="6" md="6" lg="6">
                            <div>
                                <v-icon> mdi-calendar-blank </v-icon> Data de nascimento
                            </div>
                            <v-text-field
                                color="var(--cor--preta)"
                                placeholder="dd/mm/yyyy"
                                v-mask="'##/##/####'"
                                v-model="profileObject.birthday"
                                clearable
                                @input="inputHasChanged()"
                                @change="$v.profileObject.birthday.$touch()"
                                @blur="$v.profileObject.birthday.$touch()"
                                :error-messages="birthdayErrors"
                            ></v-text-field>
                        </v-col>

                        <v-col sm="6" md="12" lg="6">
                            <div>
                                <v-icon> mdi-gender-male-female </v-icon> Gênero
                            </div>
                            <v-select
                                :items="gender"
                                item-text="name"
                                item-value="id"
                                v-model="profileObject.genderId"
                                color="var(--cor--preta)"
                                @input="inputHasChanged()"
                            ></v-select>
                        </v-col>
                        
                    </v-row>
                    
                </v-form>

                <v-row v-if="mobileVersion && !profileObject.facebookConnected" class="flex-col-center" :loading="loadingFacebookBtn" :class="!mobileVersion? 'w-80' : 'w-100'" @click="connectFacebook()">
                    <v-btn color="var(--cor--facebook)" class="custom-btn facebook-btn">
                        <v-icon left size="18" color="var(--cor--branco)"> mdi-facebook </v-icon>
                        <span class="btn__text-icon facebook-btn__text text-none"> Vincular facebook </span>
                    </v-btn>
                </v-row>

                <v-btn v-if="mobileVersion && profileObject.facebookConnected" color="var(--cor--facebook)" :loading="loadingFacebookBtn" outlined class="custom-btn" @click="disconnectFacebook()">
                    <v-icon left color="var(--cor--facebook)"> mdi-facebook </v-icon>
                    <span class="btn__text-icon text-none"> Desvincular facebook </span>
                </v-btn>

                <v-row class="flex-col-center" :class="!mobileVersion? 'w-80' : 'w-100'">
                    <v-col v-if="!mobileVersion" xs="12" sm="12" md="12" lg="12" class="w-80 flex-row-center">
                        <v-btn :color="currentCompany.primaryColor" class="text-none w-100" :loading="saveBtnLoading" :disabled="!valid" @click="saveFormInfo()" >
                            <span class="text-white text-none"> Salvar </span>
                        </v-btn>
                    </v-col>
                    <div class="text-switch w-100">
                        <h4> Aceito receber comunicações e ofertas via e-mail </h4>

                        <v-spacer></v-spacer>

                        <v-switch v-model="emailSubscribed" hide-details light :color="emailSubscribed? 'success' : 'var(--cor--roza)'"></v-switch>
                    </div>

                    <div class="text-switch w-100">
                        <h4> Aceito receber comunicações e ofertas via SMS </h4>

                        <v-spacer></v-spacer>

                        <v-switch v-model="smsSubscribed" hide-details light :color="smsSubscribed? 'success' : 'var(--cor--roza)'"></v-switch>
                    </div>

                     <div v-if="browserHasSupportedModel" class="text-switch w-100">
                        <h4> Aceito receber comunicações e ofertas via notificações </h4>

                        <v-spacer></v-spacer>

                        <v-switch v-model="wantNotificationsModel" hide-details light :color="wantNotificationsModel? 'success' : 'var(--cor--roza)'"></v-switch>
                    </div>
                </v-row>

                <div class="margin-top-divider-30" />

                <v-row class="flex-col-center w-100" >
                    <v-col v-if="mobileVersion" xs="12" sm="12" md="12" lg="12" class="w-100 flex-row-center">
                        <v-btn :color="currentCompany.primaryColor" class="text-none w-100" :loading="saveBtnLoading" :disabled="!valid" @click="saveFormInfo()" >
                            <span class="text-white text-none"> Salvar </span>
                        </v-btn>
                    </v-col>
                    <v-col xs="12" sm="12" md="12" lg="12" class="w-100 flex-row-center">
                        <v-btn v-if="mobileVersion" :color="currentCompany.buttonsColor" text class="custom-btn" @click="openChangePasswordModal()">
                            <span class="text-none"> Alterar senha </span>
                        </v-btn>
                        <v-btn v-if="mobileVersion" color="var(--cor--roza)" text class="custom-btn">
                            <span class="text-none"> Excluir conta </span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        
        <div v-if="changePasswordModalDialog">
            <changePasswordModal :dialog="changePasswordModalDialog" @closeChangePasswordModal="changePasswordModalDialog = $event"/>
        </div>

        <div v-if="deleteAccountModalDialog">
            <deleteAccountModal :dialog="deleteAccountModalDialog" @closeDeleteAccountModal="deleteAccountModalDialog = $event"/>
        </div>
    </v-container>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Plugins
import { required, email, minLength } from 'vuelidate/lib/validators'

//Functions
import { completeNameRule, telephoneRule} from "@/support/functions/validation.function";
import { upperCaseCompleteName } from "@/support/functions/name.functions";
import { cpfRule } from "@/support/functions/validation.function";

//Models
import profileModel from "@/domain/models/profile-models/profile-model";

//Services
import { 
    getContactInfoByCurrentIdAndCompanyId, 
    updateContactByCurrentId, 
    updateImageByCurrentContactId, 
    updateEmailSubscriptionByCurrentIdAndCompanyId, 
    updateSmsSubscriptionByCurrentIdAndCompanyId, 
    deleteCompanyContactByCurrentContactIdAndCompanyId,
    updateFacebookAccessTokenByCurrentContactId,
    deleteFacebookAccessTokenByCurrentContactId,
    sendConfirmationEmailByCompanyIdAndCurrentId,
    buscarCidadeIntegracao,
    buscarEstado
} from "./service/profile.service";
import { updatePushSubscriptionByCurrentIdAndCompanyId } from "@/support/push-notification/push-notification.service"

//Components
import changePasswordModal from "@/app/modals/change-password-modal/change-password.modal";
import deleteAccountModal from "@/app/modals/delete-account-confirmation-modal/delete-account-modal";

export default {
    name: 'Profile',
    components: { changePasswordModal, deleteAccountModal },
    computed: {
        ...mapGetters(
            'authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        ),
        ...mapGetters(
            'userStore', {
                userImage:  'get_userImage'
            }
        ),
        ...mapGetters(
            'pushNotificationStore', {
                wantNotifications: 'get_wantNotification'
            }
        ),
        ...mapGetters(
            'pushNotificationStore', {
                browserHasSupported: 'get_browserHasSupported'
            }
        ),
        completeNameErrors () {
            const errors = []
            if (!this.$v.profileObject.name.$dirty) return errors
            !this.$v.profileObject.name.required && errors.push('Nome completo é obrigatório.')
            !this.$v.profileObject.name.completeNameRule && errors.push('É preciso informar o nome completo.')
            return errors
        },
        emailErrors () {
            const errors = []
            if (!this.$v.profileObject.email.$dirty) return errors
            !this.$v.profileObject.email.required && errors.push('E-mail é obrigatório.')
            !this.$v.profileObject.email.email && errors.push('E-mail inválido.')
            return errors
        },
        telephoneErrors () {
            const errors = []
            if (!this.$v.profileObject.telephone.$dirty) return errors
            !this.$v.profileObject.telephone.required && errors.push('Telefone é obrigatório.')
            !this.$v.profileObject.telephone.telephoneRule && errors.push('Telefone inválido.')
            return errors
        },
        cidadeErrors () {
            const errors = []
            if (!this.$v.profileObject.cidade.$dirty) return errors
            !this.$v.profileObject.cidade.required && errors.push('Cidade é obrigatório.')
            return errors
        },
        birthdayErrors () {
            const errors = []
            if (!this.$v.profileObject.birthday.$dirty) return errors
            !this.$v.profileObject.birthday.minLength && errors.push('Data inválida.')
            return errors
        },
        cpfErrors(){
            const errors = []
            if (!this.$v.profileObject.cpf.$dirty) return errors
            !this.$v.profileObject.cpf.minLength && errors.push('cpf inválido.')
            return errors            
        }
    },
    validations: {
      profileObject: {
          name: { completeNameRule, required },
          cidade: { required },
          email: { email, required },
          telephone: { telephoneRule, required },
          birthday: { minLength: minLength(10) },
          cpf: { required, cpfRule, minLength: minLength(12)  }
      }
    },
    data: () => ({
        primaryColor: 'var(--cor--azul)',
        btnColor: 'blue',
        profileObject: {},
        emailSubscribed: null,
        smsSubscribed: null,
        switchEmail: false,
        switchSms:   true,
        gender: [
            { name: 'Masculino', id: 1 },
            { name: 'Feminino', id: 2 }
        ],
       estados: [],
       estado: null,
        search: null,
        cidades: [],
        genderValue: 1,
        dynamicMdPicture: 4,
        dynamicMdForm: 8,
        mobileVersion: false,
        showSaveButton: false,
        emailCount: 0,
        smsCount: 0,
        notificationCount: 0,
        uploadBtnLoading: false,
        changePasswordModalDialog: false,
        saveBtnLoading: false,
        deleteAccountModalDialog: false,
        valid: false,
        loadingFacebookBtn: false,
        wantNotificationsModel: null,
        browserHasSupportedModel: null,
        confirmationBtnLoader: false,
        emailConfirmed: false
    }),
    watch: {
        emailSubscribed() {
            this.emailCount++
            if( this.emailCount > 1 ) {
                updateEmailSubscriptionByCurrentIdAndCompanyId( this.currentCompany.id, this.emailSubscribed )
                    .then( )
                    .catch( error => {
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
            }
        },
        smsSubscribed() {
            this.smsCount++
            if( this.smsCount > 1 ) {
                updateSmsSubscriptionByCurrentIdAndCompanyId( this.currentCompany.id, this.smsSubscribed )
                    .then( )
                    .catch( error => {
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
            }
        },
        wantNotificationsModel() {
            this.notificationCount++
            if( this.notificationCount > 1 ) {
                const currentCall = this.wantNotificationsModel
                updatePushSubscriptionByCurrentIdAndCompanyId( this.currentCompany.id, this.wantNotificationsModel )
                .then( () => {
                        this.SET_CHANGE_ROTINE(currentCall)
                        this.SET_LOCAL_WANT_NOTIFICATION(currentCall)                       
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
            }
        },
        search (val) {
        // if(val) this.profileObject.cidadenome = val;
        
        this.fetchEntriesDebounced()
       },
       estado (val, old){
        if(val) {
          if(!old)  this.profileObject.cidade = null;
            this.buscarCidades()
        } else this.profileObject.cidade = null;
     }
    },
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
        this.getAllScreenInfo()
        this.wantNotificationsModel = this.wantNotifications //Pega valor atual de wanNotification
        this.browserHasSupportedModel = this.browserHasSupported //Pega valor atual de suporte ao navegador
        this.buscaEstados()
      

    },
    methods: {
        ...mapActions('pushNotificationStore', ['SET_LOCAL_WANT_NOTIFICATION']),
        ...mapActions('userStore', ['SET_USER_IMAGE','GET_USER_IMAGE']),
        ...mapActions('authenticateStore', ['FACEBOOK_LOGIN', 'FACEBOOK_LOGOUT']),
        ...mapActions('profileLoaderStore', ['SET_CONTACTINFO_STATE']),
        ...mapActions('pushNotificationStore', ['SET_CHANGE_ROTINE']),
        compareWidth() {
            if( window.innerWidth <= 960 ){
              this.dynamicMdPicture = 12;
              this.dynamicMdForm = 12;
              this.mobileVersion = true;
              this.avatarDynamicSize = '120px'
              
            } else {
                this.dynamicMdPicture = 4;
                this.dynamicMdForm = 8;
                this.mobileVersion = false;
                this.avatarDynamicSize = '140px'

            }
        },
        inputHasChanged() {
            this.showSaveButton = true
        },
        buscarCidades(){            
              if(this.estado){
                 let searchFormatted = !this.search ? '' : this.search.toString().toUpperCase(); 
                    buscarCidadeIntegracao(this.estado, searchFormatted).then((response) => {
                    this.cidades = response.data;
                   
                }).catch((e) => {
                    console.log('error', e)
                })
              }
         },
          buscaEstados(){
                    buscarEstado().then((response) => {
                    this.estados = response.data;
                }).catch((e) => {
                    console.log('error', e)
                })
         },
          fetchEntriesDebounced() {
            // cancel pending call
            clearTimeout(this._timerId)

                            // delay new call 500ms
                            this._timerId = setTimeout(() => {
                            this.buscarCidades()
                            }, 500)
            },
        getAllScreenInfo() {
            getContactInfoByCurrentIdAndCompanyId( this.currentCompany.id )
                .then( success => {
                        this.profileObject = new profileModel(success.data)
                        this.emailSubscribed = success.data.emailSubscribed
                        this.smsSubscribed = success.data.smsSubscribed
                        this.emailConfirmed = success.data.emailConfirmed
                        this.SET_CONTACTINFO_STATE(true)

                        console.log('profile: ', this.profileObject)

                            //   if(this.profileObject.city) {  
                            //     let auxCidade = []
                            //     auxCidade.push({
                            //         nome: this.profileObject.cidadenome,
                            //         codigo: this.profileObject.cidade,
                            //         codUf:1
                            //     })

                            //     this.cidades = auxCidade;
                            // } else this.buscarCidades()
                               if(this.profileObject.city) {  
                                    this.buscaEstados()
                                    this.estado = this.profileObject.city.stateId
                                    //   this.buscarCidades()
                                        let auxCidade = []
                                        auxCidade.push({
                                            name: this.profileObject.city.name,
                                            id: this.profileObject.city.id,
                                            stateId: this.profileObject.city.stateId
                                        })
                                        this.cidades = auxCidade;
                                        
                                        setTimeout(() => {
                                            this.profileObject.cidade = this.profileObject.city.id
                                        }, 100);
                                        
                                    } else this.buscarCidades()
                            
                    }
                )
                .catch( error => {
                        this.SET_CONTACTINFO_STATE(true)

                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        saveFormInfo() {
            if( this.valid ) {
                this.saveBtnLoading = true               
                updateContactByCurrentId( this.profileObject )
                    .then( () => {
                            this.$toasted.show('Dados salvos com sucesso!', { type: 'success' } )
                            this.showSaveButton = false
                            this.saveBtnLoading = false
                        }
                    )
                    .catch( error => {
                            this.saveBtnLoading = false
    
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
            }
        },
        buttonUploadClick() {
            this.$refs.fileInput.click();
        },
        uploadImage( filesList ) {

            let image = new FormData()
            image.append('file', filesList[0], filesList[0].name)

            updateImageByCurrentContactId( image )
                .then( success => {
                        this.uploadBtnLoading = true;

                        this.GET_USER_IMAGE()
                            .then( image => {
                                    this.SET_USER_IMAGE(image)
                                    this.uploadBtnLoading = false;
                                }
                            )
                            .catch( error => {
                                    this.uploadBtnLoading = false;

                                    if (error != null) {
                                        this.$toasted.show(error.message, { type: 'error' } )
                                    }
                                }
                            )
                    }
                )
                .catch( error => {
                    this.uploadBtnLoading = false;
                        if( error != null ) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        deleteAccount() {
            deleteCompanyContactByCurrentContactIdAndCompanyId( this.currentCompany.id )
                .then( () => {
                        this.$toasted.show('Conta excluída com sucesso!', { type: 'success' } )
                    }
                )
                .catch( error => {
                        if( error != null ) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        openChangePasswordModal() {
            this.changePasswordModalDialog = true
        },
        opneModalDeleteAccount() {
            this.deleteAccountModalDialog = true
        },
        setUpperCaseName() {
            if( completeNameRule(this.profileObject.name) ) {
                this.profileObject.name = upperCaseCompleteName(this.profileObject.name)
            }
        },
        connectFacebook() {
            this.loadingFacebookBtn = true
           this.FACEBOOK_LOGIN()
                .then( success => {
                        updateFacebookAccessTokenByCurrentContactId( success.accessToken )
                            .then( () => {
                                    this.profileObject.facebookConnected = true
                                    this.loadingFacebookBtn = false
                                }
                            )
                            .catch( error => {
                                    this.loadingFacebookBtn = false
                                    if( error != null ) {
                                        this.$toasted.show(error.message, { type: 'error' } )
                                    }
                                }
                            )
                    }
                )
                .catch( error => {
                        this.loadingFacebookBtn = false
                        if( error == 'Não foi possível entrar com o Facebook!' ) {
                            this.$toasted.show('Não foi possível vincular sua conta do facebook!' , { type: 'error' } )
                        }
                    }
                )
        },
        disconnectFacebook() {
            this.loadingFacebookBtn = true
            this.FACEBOOK_LOGOUT()
                .then( () => {
                        deleteFacebookAccessTokenByCurrentContactId()
                            .then( () => {
                                    this.profileObject.facebookConnected = false
                                    this.loadingFacebookBtn = false
                                }
                            )
                            .catch( error => {
                                    this.loadingFacebookBtn = false
                                    
                                    if( error != null ) {
                                        this.$toasted.show(error.message, { type: 'error' } )
                                    }
                                }
                            )
                    }
                )
                .catch( () => {
                        this.$toasted.show('Não existe facebook vinculado a essa conta', { type: 'error' } )
                        this.profileObject.facebookConnected = false
                        this.loadingFacebookBtn = false
                    }
                )
        },
        reSendConfirmation() {
            this.confirmationBtnLoader = true
            sendConfirmationEmailByCompanyIdAndCurrentId(this.currentCompany.id)
                .then(() => this.confirmationBtnLoader = false)
                .catch( error => {
                        this.confirmationBtnLoader = false
                        this.$toasted.show(error.message , { type: 'error' } )
                    }
                )
        }
    }
}
</script>

<style scoped>

::v-deep .custom-btn.theme--light.v-btn {
    color: var(--cor--branco);
}

/* Responsivity */
@media (min-width: 769px) and (max-width: 840px) {
    .text-switch {
        font-size: 14px;
    }
}
@media (max-width: 768px) {
    .profile__picture {
        margin-bottom: 0px !important;
    }
}

@media (max-width: 330px) {
    .text-switch {
        font-size: 14px;
    }
}

@media(max-width: 600px){
    .profile-responsive__row{
        display:flex;
        flex-direction: column !important;
    }
    .profile-form__row{
        flex-direction: column !important;
    }
}
/*========== Botão de swith ==========*/
::v-deep .theme--light.v-input--switch .v-input--switch__track {
    color: var(--cor--roza) ;
}
::v-deep .theme--light.v-input--switch .v-input--switch__thumb {
    color: var(--cor--roza) ;
}
/*========== text-field ==========*/
::v-deep .v-text-field {
    padding-top: 0px !important;
}

.text-right {
    margin-left: 4px;
}
.container-picture-name {
    display: flex;
    flex: auto !important;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.container-name {
    padding-left: 15px;
}
.profile__picture__container {
    display: flex;
    flex: auto !important;
    flex-direction: column;
    justify-content: start;
    align-items: center
}
.profile__title {
    margin-bottom: 30px;
}
.profile__picture {
    margin-bottom: 30px;
}
.profile__picture__container .v-btn {
    margin-bottom: 18px;
}
.img-container {
    display: flex;
    flex: auto !important;
    align-items: baseline;
}
.icon-container {
    cursor: pointer;
    width: 100%;
    height: 25px;
    display: flex;
    flex: auto !important;
    justify-content: center;
    align-items: center;
    background-color: var(--cor--branco);
    position: absolute;
    bottom: 2px;
}
.icon-img {
    height: 20px;
    width: 20px;
}

.facebook-btn {
    width: 193px;
}
.facebook-btn__text {
    color: var(--cor--branco);
}

.text-switch {
    display: flex;
    flex: auto !important;
    align-items: baseline;
    justify-content: center;
    padding: 0px 12px;
}

</style>